import { render, staticRenderFns } from "./ModalTwo.vue?vue&type=template&id=54ee1d6e&"
import script from "./ModalTwo.vue?vue&type=script&lang=js&"
export * from "./ModalTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports